exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bgBox[data-v-2af9dbee] {\n  width: 100%;\n  min-height: 100%;\n  background: url(https://static.soyoung.com/sy-pre/back_op-1596107400733.png) #FF8F8F;\n  background-size: 100%;\n}\n.bgBox .btnBox[data-v-2af9dbee] {\n  width: 11.15rem;\n  height: 3.65rem;\n}", ""]);

// exports
